import { Pipe, PipeTransform } from '@angular/core';
import { I18nTranslator } from '../i18n/translate';
import { Variety } from '../models/lists.model';

@Pipe({
  name: 'varietySpecyFilter',
  standalone: true,
})
export class VarietySpecyPipe implements PipeTransform {
  constructor(private i18nTranslator: I18nTranslator) {}

  transform(varieties: Variety[], args: any): any {
    if (!varieties) {
      varieties = [];
    }

    const specyId = +args;
    const filtered = varieties.filter((variety) => variety.specy.id === specyId);

    for (let i = 0; i < filtered.length; i++) {
      const variety = filtered[i];
      if (variety.code === 'OTHER') {
        if (filtered.length === 1) {
          // la seule
          variety.label = this.i18nTranslator.translate('parcel.edit.variete.all');
        } else {
          variety.label = this.i18nTranslator.translate('parcel.edit.variete.autre');
        }
        if (i !== 0) {
          filtered.splice(i, 1);
          filtered.unshift(variety);
        }
        break;
      }
    }

    return filtered;
  }
}
